// removed by extract-text-webpack-plugin
module.exports = {"container":"_1Is4dHUePn1fyfMMlSDUfd","button":"_1jAeWOii0l2wQpIMeW-Bg3"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Organizations/Administration/Main/styles.css
// module id = 2986
// module chunks = 0